// @ts-nocheck

import { createSelector } from 'reselect';

import { getMatchIdFromProps } from '../../selectors/_propsGetters_';
import { selectEntitiesCategories } from '../../selectors/entities/categories/entitiesCategoriesPrimary.selector';
import { selectEntitiesMatchesEntity } from '../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { MatchEntity } from '../../states/entities/matches';
import PeriodIds from '../../types/periodIds';
import { SportIds } from '../../types/sports';
import MatchUtils from '../../utils/match';

const makeMultimatchItemPropsSelector = () => {
  const selectMatchRegularScores = createSelector([selectEntitiesMatchesEntity], (match) => {
    let scores = null;
    if (typeof match?.setScores === 'string') {
      scores = match.setScores.split(' - ');
    }

    if (match?.sportId === SportIds.SOCCER && scores) {
      return { score1: MatchUtils.computeScore(scores, 0), score2: MatchUtils.computeScore(scores, 1) };
    }
    return MatchEntity.getScores(match);
  });

  const selectIsMatchOvertime = createSelector([selectEntitiesMatchesEntity], (match) => {
    if (match?.sportId === SportIds.SOCCER && typeof match?.setScores === 'string') {
      return match.setScores.split(' - ').length > 2;
    }
    return match?.periodId === PeriodIds.PERIOD_ID_OVERTIME;
  });

  return createSelector(
    [
      getMatchIdFromProps,
      selectEntitiesMatchesEntity,
      selectMatchRegularScores,
      selectIsMatchOvertime,
      selectEntitiesCategories,
    ],
    (matchId, match, scores, isOvertime, categories) => {
      const categoryFlag = categories?.[match?.categoryId]?.flag;
      return {
        matchId,
        flagId: categoryFlag,
        matchStart: match?.matchStart,
        competitor1Name: match?.competitor1Name,
        competitor1Flag: match?.competitor1Flag,
        competitor2Name: match?.competitor2Name,
        competitor2Flag: match?.competitor2Flag,
        homeScore: scores.score1,
        awayScore: scores.score2,
        status: match?.status,
        isOvertime,
      };
    },
  );
};

export default makeMultimatchItemPropsSelector;
